import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";
// import Select from "react-select";
// import makeAnimated from "react-select/animated";
// import CreatableSelect from "react-select/creatable";
// import { getRequest } from "services/api";
// import { buildQueryString } from "utils/queryHelpers";
import { useProduct } from "contexts/v1/masterData/ProductContext";

// const animatedComponents = makeAnimated();

const CreatePage = ({ initialData, onSuccess, onError }) => {
  const API_URL = "/agent";
  const { products} = useProduct();
  console.log("Initial Data", initialData);

  // Menambahkan state untuk menyimpan products
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    description: "",
    color: "#ffffff",
    products: [], // Array produk
  });

  const isUpdateMode = !!initialData; // Cek apakah ini update mode atau create mode

  // API hook untuk create dan update
  const { createData: createProduct } = useCreateData(
    API_URL,
    "agents"
  );
  const { updateData: updateProduct } = useUpdateData(
    `${API_URL}/${initialData?.id}`,
    "agents"
  );

  // Gunakan hook untuk menangani perubahan form
  const handleChange = useFormChangeHandler(setFormData);

  // Gunakan hook untuk menangani pengiriman form
  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    isUpdateMode ? updateProduct : createProduct,
    onSuccess,
    onError
  );

  // const handleBeforeSubmit = (e) => {
  //   e.preventDefault();
  //   const payload = {
  //     ...formData,
  //     // labels: formData.labels.map((label) => label.__isNew__ ? label.label : label.value),
  //   };

  //   handleSubmit(payload, e);
  // };

  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
      products: formData.products.map((product) => ({
        product_id: product.product_id,
        price: product.price, // Harga dalam bentuk angka murni
      })),
    };

    handleSubmit(payload, e);
  };

  // useEffect(() => {
  //   // Jika data produk berubah (untuk update), isi ulang form data
  //   if (initialData) {
  //     setFormData({
  //       name: initialData.name,
  //       email: initialData.email,
  //       phone: initialData.phone,
  //       address: initialData.address,
  //       description: initialData.description,
  //       color: initialData.color,
  //       products: initialData.products.map((product) => ({
  //         product_id: product.id,
  //         price: product.pivot.price,
  //       })),
  //     }); // Sesuaikan dengan struktur initialData
  //   }
  // }, [initialData]);

  // Saat komponen dirender, inisialisasi `formData.products` dengan data dari `products.data`
  // useEffect(() => {
  //   setFormData({
  //     products: products.data.map((product) => ({
  //       product_id: product.id,
  //       price: product.price,
  //     })),
  //   });
  // }, [products.data]);

  // useEffect(() => {
  //   if (products.data.length > 0) {
  //     // Buat formData.products berdasarkan initialData dan products.data
  //     const updatedProducts = products.data.map((product) => {
  //       // Cari apakah produk ini sudah ada di initialData
  //       const initialProduct = initialData?.products?.find(
  //         (p) => p.id === product.id
  //       );

  //       return {
  //         product_id: product.id,
  //         price: initialProduct
  //           ? initialProduct.pivot.price_agent
  //           : product.price, // Gunakan harga dari initialData jika ada
  //       };
  //     });

  //     setFormData((prev) => ({
  //       ...prev,
  //       name: initialData?.name || "",
  //       email: initialData?.email || "",
  //       phone: initialData?.phone || "",
  //       address: initialData?.address || "",
  //       description: initialData?.description || "",
  //       color: initialData?.color || "#000000",
  //       products: updatedProducts, // Produk dengan kombinasi initialData dan products.data
  //     }));
  //   }
  // }, [initialData, products.data]);
  useEffect(() => {
    if (products.data && products.data.length > 0) {
      // Buat formData.products berdasarkan initialData dan products.data
      const updatedProducts = products.data.map((product) => {
        // Cari apakah produk ini sudah ada di initialData
        const initialProduct = initialData?.products?.find(
          (p) => p.id === product.id
        );

        return {
          product_id: product.id,
          price: initialProduct
            ? parseFloat(initialProduct.pivot.price_agent) // Ambil harga dari initialData jika ada
            : parseFloat(product.price), // Ambil harga default dari products.data
        };
      });

      setFormData((prev) => ({
        ...prev,
        name: initialData?.name || "",
        email: initialData?.email || "",
        phone: initialData?.phone || "",
        address: initialData?.address || "",
        description: initialData?.description || "",
        color: initialData?.color || "#ffffff",
        products: updatedProducts, // Produk dengan kombinasi initialData dan products.data
      }));
    }
  }, [initialData, products.data]);

  // Format angka menjadi string ribuan (contoh: 1000000 -> "1.000.000")
  const formatPrice = (price) => {
    if (!price || isNaN(price)) return "0";
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  // Ubah string ribuan menjadi angka murni (contoh: "1.000.000" -> 1000000)
  const parsePrice = (formattedPrice) => {
    if (!formattedPrice) return 0;
    const parsed = parseInt(formattedPrice.replace(/\./g, ""), 10);
    return isNaN(parsed) ? 0 : parsed;
  };

  const handlePriceChange = (index, value) => {
    const parsedValue = parsePrice(value); // Konversi nilai ke angka murni
    if (parsedValue >= 0) {
      setFormData((prev) => ({
        ...prev,
        products: prev.products.map((product, i) =>
          i === index ? { ...product, price: parsedValue } : product
        ),
      }));
    }
  };

  return (
    <form
      onSubmit={(e) => handleBeforeSubmit(e)}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      <div className="action-sheet-content flex-grow-1">
        {/* Agent Name */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="name"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Agent Name:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.name && "is-invalid"
              )}
              id="name"
              placeholder="Agent Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              required
              minLength={3}
            />
            {formError?.name && (
              <div className="invalid-feedback">{formError.name}</div>
            )}
          </div>
        </div>
        {/* Email */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="email"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Email:
          </label>
          <div className="col-sm-8">
            <input
              type="email"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.email && "is-invalid"
              )}
              id="email"
              placeholder="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
            />
            {formError?.email && (
              <div className="invalid-feedback">{formError.email}</div>
            )}
          </div>
        </div>

        {/* Phone */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="phone"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Phone:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.phone && "is-invalid"
              )}
              id="phone"
              placeholder="Phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              pattern="^[0-9]*$"
            />
            {formError?.phone && (
              <div className="invalid-feedback">{formError.phone}</div>
            )}
          </div>
        </div>

        {/* Color Picker */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="color"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Color:
          </label>
          <div className="col-sm-8">
            <input
              type="color"
              className="form-control"
              id="color"
              name="color"
              value={formData.color}
              onChange={handleChange}
              disabled={isSubmitting}
            />
          </div>
        </div>

        {/* Description */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="description"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Description:
          </label>
          <div className="col-sm-8">
            <textarea
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.description && "is-invalid"
              )}
              id="description"
              placeholder="Short description about the agent"
              name="description"
              value={formData.description}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "70px" }}
            />
            {formError?.description && (
              <div className="invalid-feedback">{formError.description}</div>
            )}
          </div>
        </div>

        {/* address */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="address"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Address:
          </label>
          <div className="col-sm-8">
            <textarea
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.address && "is-invalid"
              )}
              id="address"
              placeholder="Address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "70px" }}
            />
            {formError?.address && (
              <div className="invalid-feedback">{formError.address}</div>
            )}
          </div>
        </div>

        {/* form profuk */}
        <div className="row mb-3 align-items-center">
          <label
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Products:
          </label>
          <div className="col-sm-8">
            {formData.products.map((product, index) => {
              // Cari nama produk berdasarkan product_id
              const productName = products.data.find(
                (p) => p.id === product.product_id
              )?.name;

              return (
                <div
                  key={product.product_id}
                  className="d-flex align-items-center mb-2"
                >
                  {/* Nama Produk (Read-only) */}
                  <input
                    type="text"
                    className="form-control me-2"
                    placeholder="Product Name"
                    value={productName || ""}
                    readOnly
                  />
                  {/* Input untuk Harga */}
                  {/* <input
                    type="number"
                    className="form-control me-2"
                    placeholder="Price"
                    // value={product.price}
                    value={formatPrice(product.price)} // Tampilkan harga dengan format ribuan
                    onChange={(e) => handlePriceChange(index, e.target.value)}
                    required
                  /> */}
                  {/* Input untuk Harga */}
                  <input
                    type="text"
                    className="form-control me-2"
                    placeholder="Masukkan harga"
                    value={formatPrice(product.price)} // Tampilkan harga dengan format ribuan
                    onChange={(e) => handlePriceChange(index, e.target.value)}
                    required
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Submit Button */}
      <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isSubmitting}
        >
          {isUpdateMode ? "Update Agent" : "Create Agent"}
        </button>
      </div>
    </form>
  );
};

export default CreatePage;
